interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  actionLabel,
  onAction,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="mb-3 flex items-center gap-3">
          <span className="font-heading text-sm font-bold text-primary-500">{index}</span>
          <span className="h-px w-8 bg-primary-300" />
          <span className="text-xs font-medium uppercase tracking-[0.25em] text-secondary-600">
            {eyebrow}
          </span>
        </div>
        <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>
        ) : null}
      </div>
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-base" />
        </button>
      ) : null}
    </div>
  );
}